import React from 'react';
import Translate from 'react-translate-component';
import { contains } from 'ramda';

export const CompanyContacts = ({ translate, contacts }) => contacts ? (
    <dl className='dl-horizontal'>
        <Translate
            component='dt'
            content={translate}
            fallback={translate}
            className='vertical-align-top'
        />
        <dd>
            <ul className='company-contacts'>
            { contacts.map((text, index) => (
                    contains('@', text) ? (
                        <li key={ index }><a href={ `mailto:${ text }` } >{ text }</a></li>
                    ) : (
                        <li key={ index }><span>{ text }</span></li>
                    )
                ))}
            </ul>
        </dd>
    </dl>
) : null;
